/* istanbul ignore file */
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
export class CarServicePreferencesFormGroup extends PersistentFormGroup<{
    specialNeeds: PersistentFormControl<string>;
}> {
    public static create(value: FormGroupValueOf<CarServicePreferencesFormGroup>): CarServicePreferencesFormGroup {
        return new CarServicePreferencesFormGroup({
            specialNeeds: new PersistentFormControl(value.specialNeeds, [
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
        });
    }
}
@Component({
    selector: 'medpace-transfer-preferences',
    templateUrl: './transfer-preferences.component.html',
    styleUrls: ['./transfer-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsTextFieldComponent],
})
export class TransferPreferencesComponent {
    public readonly formGroup: InputSignal<CarServicePreferencesFormGroup> =
        input.required<CarServicePreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
